import React, { useState } from 'react';
import { BannerSignIn } from './style';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import { useConfigContext } from '../../../../contexts/ConfigContext';
import SignIn from '../SignIn';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useUserContext } from '../../../../contexts/UserContext';
import { useSignInContext } from '../../../../contexts/SignInContext';

const SignInOrchestration = () => {
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState(undefined);
  const { language } = useLanguageContext();
  const { DI_ENDPOINT_GCP } = useConfigContext();
  const { user } = useUserContext();
  const { signInBox } = useSignInContext();

  const toggleModal = () => {
    if (modal) setIsLoginLoading(false);
    setModal(!modal);
  };

  const submitFormPost = (actionUrl, fields) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = actionUrl;
    Object.entries(fields).forEach(([name, value]) => {
      if (value == null) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  const continueClick = email => {
    setIsLoginLoading(true);
    const [diLanguage, country] = language.locale.split('-');
    submitFormPost(DI_ENDPOINT_GCP, {
      email,
      lang: language.locale,
      c: country.toUpperCase(),
      l: diLanguage.toLowerCase(),
      state: `lang|${language.locale}`,
    });
  };

  return !user.isActive ? (
    <>
      <BannerSignIn isOpenSigninBox={signInBox}>
        <SignIn isLoading={isLoginLoading} onContinue={email => continueClick(email)} />
      </BannerSignIn>
      <div>
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Select Your Experience</ModalHeader>
          {modalContent &&
            modalContent.map(c => (
              <ModalBody key={c.description}>
                <Button color="primary" onClick={() => c.action()}>
                  {c.description}
                </Button>
              </ModalBody>
            ))}
        </Modal>
      </div>
    </>
  ) : null;
};

export default SignInOrchestration;